import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, LL_H_C } from '@nu-art/thunderstorm-frontend';
import { contextCloseMode_Force, provideInfoContextKey_Expression, provideInfoContextKey_Protocol, provideInfoContextKey_Score } from '../../../../../modules/provide-info/types.js';
import { ModuleFE_ProvideInfo } from '../../../../../modules/provide-info/ModuleFE_ProvideInfo.js';
import './Component_ProvideInfoV2_Controls.scss';
import { ModuleFE_AdvisorMini } from '../../../../../modules/ModuleFE_AdvisorMini.js';
import { PanelKey_Home } from '@app/advisor-v5-shared';
import { ModuleFE_EMInterface } from '@app/advisor-frontend/_entity/runtime/em-interface/ModuleFE_EMInterface';
import { voidFunction } from '@nu-art/ts-common';
export class Component_ProvideInfoV2_Controls extends ComponentSync {
    //######################### Life Cycle #########################
    __onProvideInfoContextChange = voidFunction;
    __onProvideInfoContextUpdate = (context) => this.forceUpdate();
    deriveStateFromProps(nextProps, state) {
        state.contextData = nextProps.contextData;
        state.type = nextProps.type;
        return state;
    }
    //######################### Logic #########################
    getPrimaryLabel = () => {
        switch (this.state.type) {
            case provideInfoContextKey_Protocol:
                return 'Save & Exit';
            case provideInfoContextKey_Expression:
                return 'Save';
            case provideInfoContextKey_Score:
                const isBase = ModuleFE_ProvideInfo.context.current.isBaseContext();
                return isBase ? 'Save & Exit' : 'Save';
        }
    };
    getSecondaryLabel = () => {
        switch (this.state.type) {
            case provideInfoContextKey_Protocol:
                return 'Discard Changes';
            case provideInfoContextKey_Expression:
                return 'Cancel';
            case provideInfoContextKey_Score:
                return ModuleFE_ProvideInfo.getBaseContext()?.key === provideInfoContextKey_Score ? 'Discard Changes' : 'Cancel';
        }
    };
    close = () => {
        const closePanels = () => {
            if (ModuleFE_AdvisorMini.getIsMiniActive())
                return ModuleFE_AdvisorMini.openPanel(PanelKey_Home);
        };
        switch (this.state.type) {
            case provideInfoContextKey_Expression:
                ModuleFE_ProvideInfo.context.current.close(contextCloseMode_Force);
                break;
            case provideInfoContextKey_Protocol: {
                closePanels();
                setTimeout(() => ModuleFE_ProvideInfo.context.chain.close(contextCloseMode_Force), 300);
                break;
            }
            case provideInfoContextKey_Score: {
                if (ModuleFE_ProvideInfo.getBaseContext()?.key !== provideInfoContextKey_Score)
                    ModuleFE_ProvideInfo.context.current.close(contextCloseMode_Force);
                else {
                    closePanels();
                    setTimeout(() => ModuleFE_ProvideInfo.context.chain.close(contextCloseMode_Force), 300);
                }
            }
        }
    };
    show = () => {
        switch (this.state.type) {
            case provideInfoContextKey_Protocol:
                return this.state.contextData.findings.hasChanges();
            case provideInfoContextKey_Score: {
                const isBase = ModuleFE_ProvideInfo.context.current.isBaseContext();
                return isBase ? this.state.contextData.findings.hasChanges() : false;
            }
            case provideInfoContextKey_Expression: {
                return false;
            }
        }
    };
    //######################### Render #########################
    render() {
        if (!this.show())
            return;
        return _jsxs(LL_H_C, { className: 'provide-info__controls', children: [this.render_Secondary(), this.render_Primary()] });
    }
    render_Primary = () => {
        const isAvatar = ModuleFE_EMInterface.isAvatarMode();
        const label = this.getPrimaryLabel();
        return _jsx(Button, { disabled: isAvatar, variant: 'primary', onClick: () => this.state.contextData.findings.save(), children: label });
    };
    render_Secondary = () => {
        const label = this.getSecondaryLabel();
        return _jsx(Button, { variant: 'secondary', onClick: () => this.close(), children: label });
    };
}
//# sourceMappingURL=Component_ProvideInfoV2_Controls.js.map